import { render, staticRenderFns } from "./wick-cell.vue?vue&type=template&id=1267c51d&"
import script from "./wick-cell.vue?vue&type=script&lang=js&"
export * from "./wick-cell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports